export default __webpack_public_path__ + "static/media/TheNewYear_14.3e532093.png";